// extracted by mini-css-extract-plugin
export default {"stopInfo":"StopsTable_stopInfo__h7Er2","plusOneBadge":"StopsTable_plusOneBadge__bEdNL"};